import { computed } from 'vue'

import { useQueryDataMonth } from '@/queries/stats/useQueryDataMonth'

/**
 * useDataMonth — the month of rate data currently loaded in Neuron.
 *
 * Sourced from Neuron's unauthenticated `/stats` endpoint via TanStack Query.
 * Signal and Signal sample mode both key off these values.
 *
 * Usage:
 *   const { dataMonth, lookbackYear } = useDataMonth()
 *   dataMonth.value.month // 'July'  (templates unwrap: `dataMonth.month`)
 */
export function useDataMonth() {
    const { data, isError, error } = useQueryDataMonth()

    return {
        dataMonth: data,
        isError,
        error,
        month: computed(() => data.value?.month ?? null),
        year: computed(() => data.value?.year ?? null),
        lastDate: computed(() => data.value?.lastDate ?? null),
        lookbackYear: computed(() => data.value?.lookbackYear ?? null),
    }
}
